import React, { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { API_URL1 } from "../services/url";
import PhoneInput from "react-phone-input-2";
import { useAlert } from "react-alert";

const useStyles = makeStyles({
  root: {
    [`& fieldset`]: {
      borderRadius: 10,
    },
  },
});

const ResetPass = () => {
  let [name, setName] = useState("");

  let [phone_no, setPhone_no] = useState("");
  let [truck, setTruck] = useState("");
  let [user, setUser] = useState([]);
  const classes = useStyles();

  const alert = useAlert();

  const handleName = (e) => {
    setName(e.target.value);
  };

  const handlephone = (e) => {
    setPhone_no(e);
  };

  const handlePhoneNo = (e) => {
    setPhone_no(e.target.value);
  };
  const handleAdd = async (event) => {
    const truckId = parseInt(truck);
    event.preventDefault();
    let phone=phone_no;
    if (phone.charAt(0) === "9" && phone.charAt(1) === "1") {
      var mob = "+91 ";

      for (let i = 2; i < phone.length; i++) {
        if (
          phone[i] !== " " &&
          phone[i] !== "(" &&
          phone[i] !== ")" &&
          phone[i] !== "-"
        )
          mob = mob + phone[i];
      }
      phone = mob;
    }
    if (phone.charAt(0) === "1") {
      var mob = "+1 ";

      for (let i = 1; i < phone.length; i++) {
        if (
          phone[i] !== " " &&
          phone[i] !== "(" &&
          phone[i] !== ")" &&
          phone[i] !== "-"
        )
          mob = mob + phone[i];
      }

      phone = mob;
    }
    const editData = {
      name: name,

      phone_no: phone,
      truck_company_id: localStorage.getItem("adminid"),
    };
    console.log("phone_no profile",phone_no)
    try {
      const response = await axios.put(
        `${API_URL1}trucker/truck/editTruckCompanyUser`,
        editData,
        {
          headers: {
            "x-access-token": `${localStorage.getItem("TruckertokenKey")}`,
            "content-type": "application/json",
          },
        }
      );
      if (response.data.success) {
        alert.success(response.data.message, {
          onClose: () => {
            window.location = "/";
          },
        });
      } else {
        alert.error("Error in update Profile", {
          onClose: () => {
            window.location = "/editUser";
          },
        });
      }
    } catch (error) {
      alert.error("Error in update Profile", {
        onClose: () => {
          // window.location = '/viewdriver';
        },
      });
    }
  };
  const getUserData = async () => {
    try {
      const res = await axios.get(
        `${API_URL1}trucker/truck/truckCompanyUser/${localStorage.getItem(
          "adminid"
        )}/${localStorage.getItem("trucker_id")}`
      );
      setName(res.data.User[0].name);
      setPhone_no(res.data.User[0].phone_no);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);
  console.log("phone_no",phone_no)
  const companyName = localStorage.getItem("company_name") || "U";
  return (
    <div style={{ marginTop: "0px", padding: "24px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, pl: '8px' }}>
        <Box sx={{
          width: 46,
          height: 46,
          borderRadius: 2,
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 6px 12px rgba(99,102,241,0.25)'
        }}>
          <EditOutlinedIcon htmlColor="#fff" />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: 0.2 }}>
          Edit Profile
        </Typography>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: 800,
          mx: 'auto',
          background: "#ffffff",
          border: '1px solid #e5e7eb',
          boxShadow: '0 8px 20px rgba(2,6,23,0.06)',
          borderRadius: "16px",
          p: 4,
        }}
      >
        <Avatar
          sx={{
            mt: "8px",
            mb: 3,
            mx: 'auto',
            width: 100,
            height: 100,
            bgcolor: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            color: '#ffffff',
            fontWeight: 800,
            fontSize: 36,
            boxShadow: '0 8px 16px rgba(99,102,241,0.25)'
          }}
        >
          {companyName.charAt(0).toUpperCase()}
        </Avatar>

        <form onSubmit={handleAdd}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ mb: 1 }}
                fontSize="14px"
                align="left"
                fontWeight="bold"
                color="#374151"
              >
                Name
              </Typography>
              <TextField
                sx={{
                  background: '#f8fafc',
                  borderRadius: '12px!important',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                  }
                }}
                name="name"
                value={name}
                onChange={handleName}
                size="small"
                className={classes.root}
                autoComplete="given-name"
                required
                fullWidth
                placeholder="Enter your name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ mb: 1 }}
                fontSize="14px"
                align="left"
                fontWeight="bold"
                color="#374151"
              >
                Contact Number
              </Typography>
              <Box sx={{
                '& .react-tel-input': {
                  '& .form-control': {
                    background: '#f8fafc',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    width: '100%',
                    padding: '8px 14px 8px 48px',
                    fontSize: '14px',
                    '&:hover': {
                      borderColor: '#cbd5e1'
                    },
                    '&:focus': {
                      borderColor: '#6366f1',
                      boxShadow: '0 0 0 3px rgba(99,102,241,0.15)'
                    }
                  }
                }
              }}>
                <PhoneInput
                  required
                  country={"us"}
                  value={phone_no}
                  onChange={(phone_no) => handlephone(phone_no)}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3.5,
                  textTransform: "none",
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  borderRadius: "999px",
                  boxShadow: '0 8px 16px rgba(99,102,241,0.25)',
                  '&:hover': { background: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)', boxShadow: '0 12px 20px rgba(124,58,237,0.35)' }
                }}
              >
                <b> Save </b>
              </Button>
            </Grid>
          </Grid>
        </form>
      </TableContainer>
    </div>
  );
};

export default ResetPass;
